import { useModalMultiple } from '@billy/design-system'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ModalId } from '../../../enums/modalId'
import { getCurrentLocale } from '../../../utils'
import { localeToLanguage } from '../../../utils/localeToLanguage'
import { syncOpenBankingConnection } from '../query-api'

interface UseSyncOpenBankingConnectionProps {
  onSuccess?: () => void
  onError?: () => void
}

export const useSyncOpenBankingConnection = (props?: UseSyncOpenBankingConnectionProps) => {
  const { onSuccess, onError } = props || {}
  const locale = getCurrentLocale()
  const { organization } = useUserOrganization()
  const { open: openModal, close: closeModal } = useModalMultiple([
    ModalId.BankConnectionErrorModal,
    ModalId.BankConnectionExpiredModal,
    ModalId.BankConnectionSuccessModal,
  ])

  const { mutate: syncOpenBankingAccountConnection, isLoading } = useMutation(
    (aiiaBankAccountId: string) =>
      syncOpenBankingConnection({
        aiiaBankAccountId,
        locale: localeToLanguage[locale],
        organizationId: organization?.id as string,
        redirectUrl: window.location.href,
      }),
    {
      onSuccess: ({ authUrl }) => {
        if (onSuccess) {
          return onSuccess()
        }

        if (authUrl) {
          window.location.replace(authUrl)
        } else {
          closeModal(ModalId.BankConnectionExpiredModal)
          openModal(ModalId.BankConnectionSuccessModal)
        }
      },
      onError: () => {
        if (onError) {
          return onError()
        }
        openModal(ModalId.BankConnectionErrorModal)
      },
    },
  )

  return {
    isLoading,
    syncOpenBankingAccountConnection,
  }
}
